import React from "react";
import { Route } from "react-router-dom";

import ProtectedRoute from "../components/common/ProtectedRoute";

import StaffDashboard from "../pages/staff/StaffDashboard";
import LeadsManagement from "../pages/leads/LeadsManagement";
import LeadDetails from "../pages/leads/LeadDetails";
import LeadTimeline from "../pages/leads/LeadTimeline";
import LeadActivity from "../pages/leads/LeadActivity";
import VisitProofs from "../pages/leads/VisitProofs";


const StaffRoutes = () => {
  return (
    <>
      <Route
        path="/staff"
        element={
          <ProtectedRoute role="staff">
            <StaffDashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/staff/leads"
        element={
          <ProtectedRoute role="staff">
            <LeadsManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/staff/leads/:id"
        element={
          <ProtectedRoute role="staff">
            <LeadDetails />
          </ProtectedRoute>
        }
      />
      <Route
        path="/staff/leads/:id/timeline"
        element={
          <ProtectedRoute role="staff">
            <LeadTimeline />
          </ProtectedRoute>
        }
      />
      <Route
        path="/staff/leads/:id/activity"
        element={
          <ProtectedRoute role="staff">
            <LeadActivity />
          </ProtectedRoute>
        }
      />
      <Route
        path="/staff/leads/:leadId/activity/:activityId/proofs"
        element={
          <ProtectedRoute role="staff">
            <VisitProofs />
          </ProtectedRoute>
        }
      />
    </>
  );
};

export default StaffRoutes;